<template lang="pug">
  .wrap
    .main(v-if='user')
      .user-name {{ user.firstName }} {{ user.lastName }}
      .email {{ user.email }}

      el-tag(v-if='isSuperUser' type='danger') SuperAdmin

      .groups
        el-tag.group(v-for='group in assignedGroups' :key='group.id' type='gray') {{ group.name }}

      .user-actions
        .user-action
          router-link(:to='{ name: "userAccount" }')
            el-button(type="primary") Edit your account
        .user-action
          el-button(type="warning" @click="logout" :loading="logoutLoading") Sign out
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      logoutLoading: false
    };
  },
  computed: {
    ...mapGetters("auth", ["user", "assignedGroups", "isSuperUser"])
  },
  methods: {
    logout() {
      this.logoutLoading = true;
      this.$router.push({ name: "login" });
      this.$store.dispatch("auth/logout").then(() => {
        this.logoutLoading = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.user {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 20px 30px;
}

.user-name {
  font-size: 15px;
  margin-bottom: 5px;
}

.user-actions {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.user-action {
  padding: 10px 0;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border-bottom: 0;
  }

  :global(.el-button) {
    width: 100%;
  }
}
</style>
